exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__SoilSsurgoMap__loading__C9cS9 {\n  position: absolute;\n  text-align: center;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  width: 100%;\n  z-index: 450;\n}\n", ""]);

// exports
exports.locals = {
	"loading": "dmb-web__SoilSsurgoMap__loading__C9cS9"
};